<template>
  <div>
    <!-- 팝업 형태 -->
    <div class="innerItem popupType">
      <p class="innerTitle setLabel toCapitalize f_medium">{{locale.popup_type}}</p>
      <div class="flexBox">
        <div
          v-for="option in type"
          :key="option"
          class="flexInner">
          <div class="checkbox radio">
            <input type="radio" name="layerpopup_type" :id="`type_${option}`" :value="option" v-model="item.setting.type">
            <label :for="`type_${option}`">
              <img :src="require(`@/assets/img/layerpopup_${option}.png`)">
              <p class="typeName mt5">{{ locale[option] }}</p>
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- 팝업 형태 -->
    <!-- 팝업 효과 -->
    <div class="innerItem">
      <p class="innerTitle setLabel toCapitalize f_medium">{{locale.popup_effect}}</p>
      <div v-for="option in effect"
        :key="option"
        class="mt5">
        <div class="checkbox">
          <input type="checkbox" :id="`effect_${option}`" v-model="item.setting[option]">
          <label :for="`effect_${option}`">{{getEffectLabel(option)}}</label>
        </div>
      </div>
    </div>
    <!-- 팝업 효과 -->
    <!-- 팝업 닫기 옵션 -->
    <div class="innerItem">
      <p class="innerTitle setLabel toCapitalize f_medium">{{ locale.popup_close }}</p>
      <div class="limitDay">
        <div class="checkbox radio">
          <input type="radio" name="layerpopup_close" id="layerpopup_close_day" value="1day" v-model="item.setting.close" />
          <label for="layerpopup_close_day">{{locale.close_today}}</label>
          <Datetime type="time"
            v-model="limitTime"
            input-class="limitTime"
            :minute-step="1" />
          Reset time
        </div>
      </div>
      <div class="mt5">
        <div class="checkbox radio">
          <input type="radio" name="layerpopup_close" id="layerpopup_close_stay" value="stay" v-model="item.setting.close" />
          <label for="layerpopup_close_stay">{{locale.close_stay}}</label>
        </div>
      </div>
      <div class="mt5">
        <div class="checkbox radio">
          <input type="radio" name="layerpopup_close" id="layerpopup_close_every" value="every" v-model="item.setting.close" />
          <label for="layerpopup_close_every">{{ locale.close_everytime }}</label>
        </div>
      </div>
    </div>
    <!-- 팝업 닫기 옵션 -->
    <!-- 디바이스별 활성화 -->
    <div class="innerItem">
      <p class="innerTitle setLabel toCapitalize f_medium">{{locale.activate}}</p>
      <div
        v-for="option in active"
        :key="option"
        class="mt10">
        <div class="checkbox">
          <input type="checkbox" :id="`active_${option}`" :value="option" v-model="item.setting[`${option}Active`]">
          <label :for="`active_${option}`">{{ getActiveLabel(option) }}</label>
        </div>
      </div>
    </div>
    <!-- 디바이스별 활성화 -->
  </div>
</template>

<script>
import Datetime from 'vue-datetime/src/Datetime.vue'
import moment from 'moment/moment'
import regExp from '@/common/regExp'

export default {
  name: 'LayerpopupSetting',
  props: [
    'locale',
    'item'
  ],
  components: {
    Datetime
  },
  computed: {
    limitTime: {
      get () {
        const defaultTime = moment().set({ hour: 12, minute: 0, second: 0 }).toISOString()
        return this.item.setting.limitTime || defaultTime
      },
      set (data) {
        const time = moment(data).format('HH:mm')
        this.item.setting.limitTime = time
      }
    }
  },
  watch: {
    item: {
      deep: true,
      handler (data) {
        const setting = data && data.setting
        if (setting) {
          this.$emit('updateSetting', { id: data.id, setting: setting })
        }
      }
    }
  },
  data () {
    return {
      close: [
        '1day',
        'stay'
      ],
      closeReset: '1500',
      type: [
        'modal',
        'toastup'
      ],
      effect: [
        'slideup',
        'autoplay'
      ],
      active: [
        'mobile',
        'tablet',
        'otaOnly'
      ]
    }
  },
  methods: {
    getActiveLabel (option) {
      const label = regExp.camelToSnake(option)
      return this.locale[label]
    },
    getEffectLabel (option) {
      const label = `slide_${option}`
      return this.locale[label]
    }
  }
}
</script>

<style lang="scss" scoped>
.popupType {
  .flexBox {
    flex-wrap: wrap;
    margin: 0;
  }
  .flexInner {
    flex: none;
    width: 50%;
    padding: 0;
  }
  img {
    height: 100px;
  }
  .typeName {
    text-align: center;
  }
}
.limitDay {
  label {
    display: inline-block;
  }
  .vdatetime {
    display: inline-block;
    margin-left: 5px;
  }
}
</style>
